import { Container } from 'pixi.js';
import Coin from './Coin';
import { isDesktop } from 'react-device-detect';

class Coins extends Container {
	isLeft = false;
	fallConfig = {
		width: 400,
		minWidth: 400,
		height: 400,
		minHeight: 400
	};
	currentCoinsNum = 0;

	addCoins(num) {
		this.currentCoinsNum = this.currentCoinsNum + num;
		if (this.currentCoinsNum > 1) {
			while (this.currentCoinsNum > 1) {
				this.isLeft = !this.isLeft;
				var c = new Coin(this.isLeft, this.fallConfig);
				c.scale.set(isDesktop ? 0.5 : 1);
				let s = isDesktop ? 0.6 : 1 + Math.random() * 0.4;
				c.scale.set(s, s);
				this.addChild(c);
				this.currentCoinsNum = this.currentCoinsNum - 1;
			}
		}
	}
}

export default Coins;
